/**
 * @generated SignedSource<<e931679849f52598134a63ccff3121b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetStatus = "AVAILABLE" | "IN_USE" | "LOST" | "MAINTENANCE" | "RETIRED" | "%future added value";
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type OpsReservationNewPageAssetQuery$variables = {
  assetTag: any;
};
export type OpsReservationNewPageAssetQuery$data = {
  readonly asset: {
    readonly assetTag: any;
    readonly category: EquipmentCategory;
    readonly dailyRate: any | null | undefined;
    readonly kitMembers: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly name: string;
    readonly status: AssetStatus;
  } | null | undefined;
};
export type OpsReservationNewPageAssetQuery = {
  response: OpsReservationNewPageAssetQuery$data;
  variables: OpsReservationNewPageAssetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assetTag"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "assetTag",
    "variableName": "assetTag"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetTag",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dailyRate",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Asset",
  "kind": "LinkedField",
  "name": "kitMembers",
  "plural": true,
  "selections": [
    (v7/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsReservationNewPageAssetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsReservationNewPageAssetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Asset",
        "kind": "LinkedField",
        "name": "asset",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8512f270adab62194f2e62f03dd24570",
    "id": null,
    "metadata": {},
    "name": "OpsReservationNewPageAssetQuery",
    "operationKind": "query",
    "text": "query OpsReservationNewPageAssetQuery(\n  $assetTag: AssetTag!\n) {\n  asset(assetTag: $assetTag) {\n    assetTag\n    name\n    category\n    status\n    dailyRate\n    kitMembers {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff71cf0f2418bd86e9bb59d49c457e08";

export default node;
